import { Center, Select, Spinner } from '@chakra-ui/react';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import AuthContext from '../../contexts/AuthContext';
import MerchantContext from '../../contexts/MerchantContext';
import { useTRPC } from '../../trpc/client';
import AuthLoginContainer from '../AuthLoginContainer';

const OrgLoginContainer = (): JSX.Element => {
  const trpc = useTRPC();
  const navigate = useNavigate();
  const { orgId } = useParams<{ orgId: string }>();
  const { merchant, setMerchant } = useContext(MerchantContext);
  const { user, logout } = useContext(AuthContext);
  const [merchantId, setMerchantId] = useState('');

  const orgQuery = useQuery(trpc.organizations.get.queryOptions({ id: orgId ?? '' }));

  // The org login always starts logged out, so picking a merchant never skips the form.
  useEffect(() => {
    logout();
    setMerchant(undefined);
  }, [logout, setMerchant]);

  useEffect(() => {
    if (!orgQuery.isPending && !orgQuery.data) window.location.replace('https://www.palomma.com/');
  }, [orgQuery.data, orgQuery.isPending]);

  useEffect(() => {
    setMerchant(orgQuery.data?.merchants.find((m) => m.id === merchantId));
  }, [merchantId, orgQuery.data, setMerchant]);

  useEffect(() => {
    if (user && merchant) navigate(`/${merchant.id}/`);
  }, [user, merchant, navigate]);

  if (!orgQuery.data) {
    return (
      <Center height="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  return (
    <AuthLoginContainer
      org={orgQuery.data}
      merchantPicker={
        <Select
          border={'1px solid #5D5C60'}
          placeholder={`Selecciona tu ${orgQuery.data.merchantLabel ?? 'comercio'}`}
          value={merchantId}
          onChange={(e) => setMerchantId(e.target.value)}
        >
          {orgQuery.data.merchants.map((m) => (
            <option key={m.id} value={m.id}>
              {m.displayName}
            </option>
          ))}
        </Select>
      }
    />
  );
};

export default OrgLoginContainer;
